import React from 'react';
import { type TFunction } from 'i18next';

import CircleIcon from '@/components/CircleIcon/CircleIcon';
import { IndicatorChipVariant } from '@/components/statuses/IndicatorChip';
import typography from '@/theme/typography';

import { GeneralStatusEnum } from './types';

const GENERAL_STATUSES = [
  {
    label: (t: TFunction) => t('filters.options.generalStatus.active'),
    value: GeneralStatusEnum.ACTIVE,
    Icon: () => <CircleIcon fill="green.700" stroke="transparent" />
  },
  {
    label: (t: TFunction) => t('filters.options.generalStatus.draft'),
    value: GeneralStatusEnum.DRAFT,
    Icon: () => <CircleIcon stroke="primary.500" />,
    sx: {
      '&.Mui-selected .CircleIcon-root, &.IndicatorChip-clickable:hover .CircleIcon-root': {
        bgcolor: 'primary.500'
      }
    }
  },
  {
    label: (t: TFunction) => t('filters.options.generalStatus.pendingAction'),
    value: GeneralStatusEnum.PENDING_ACTION,
    Icon: () => <CircleIcon fill="orange.main" stroke="transparent" />,
    sx: {
      fontWeight: typography.fontWeightMedium
    }
  },
  {
    label: (t: TFunction) => t('filters.options.generalStatus.pendingOnboarding'),
    value: GeneralStatusEnum.PENDING_ONBOARDING,
    Icon: () => <CircleIcon fill="orange.main" stroke="transparent" />
  },
  {
    label: (t: TFunction) => t('filters.options.generalStatus.pendingOnboarding'),
    value: GeneralStatusEnum.ONBOARDING,
    Icon: () => <CircleIcon fill="orange.main" stroke="transparent" />
  },
  {
    label: (t: TFunction) => t('filters.options.generalStatus.archived'),
    value: GeneralStatusEnum.ARCHIVED,
    Icon: () => <CircleIcon fill="grey.700" stroke="transparent" />,
    sx: {
      '& .MuiChip-label': {
        color: 'grey.800'
      }
    }
  },
  {
    label: (t: TFunction) => t('filters.options.generalStatus.inactive'),
    value: GeneralStatusEnum.INACTIVE,
    Icon: () => <CircleIcon fill="grey.700" stroke="transparent" />,
    sx: {
      '& .MuiChip-label': {
        color: 'grey.800'
      }
    }
  },
  {
    label: (t: TFunction) => t('filters.options.generalStatus.onHold'),
    value: GeneralStatusEnum.ON_HOLD,
    Icon: () => <CircleIcon fill="orange.main" stroke="transparent" />
  },
  {
    label: (t: TFunction) => t('filters.options.generalStatus.cancelled'),
    value: GeneralStatusEnum.CANCELLED,
    Icon: () => <CircleIcon fill="red.900" stroke="transparent" />
  },
  {
    label: (t: TFunction) => t('filters.options.generalStatus.completed'),
    value: GeneralStatusEnum.COMPLETED,
    Icon: () => <CircleIcon fill="primary.main" stroke="transparent" />
  },
  {
    label: (t: TFunction) => t('filters.options.generalStatus.unpublished'),
    value: GeneralStatusEnum.UNPUBLISHED,
    Icon: () => <CircleIcon stroke="primary.500" />,
    sx: {
      '&.Mui-selected .CircleIcon-root, &.IndicatorChip-clickable:hover .CircleIcon-root': {
        bgcolor: 'primary.500'
      }
    }
  }
] as IndicatorChipVariant[];

export default GENERAL_STATUSES;
